import Cookies from 'js-cookie';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../login/LoginForm';
import { AuthContext } from './AuthContext';
function handleLogout() {
  // clear the cookie values
 
  {/*Cookies.remove('userId');
Cookies.remove('isLoggedIn');*/}
}

export function Logout() {
  const navigate = useNavigate();

  const { setUserData } = useContext(UserContext);

  setUserData({
    isLoggedIn: false,
    userId: null,
  });
  // redirect the user to the login page
  navigate('/home');

  return null;
}


{/*import { useCookies } from 'react-cookie';

function Logout() {
  const [cookies, setCookie, removeCookie] = useCookies(['auth']);

  const handleLogout = () => {
    removeCookie('auth');
  }

  handleLogout();

  // Redirect the user to the login page
  history.push('/login');

  return null;
}*/}


export default Logout ;